import qs from 'qs';
import { trackPromise } from 'react-promise-tracker';

import api from '../../../utils/API';
import { getCliente } from '../../../utils/client';

export const getCampanhas = params => {
  const cliente = getCliente();
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/campaigns`,
      method: 'GET',
      expectToken: true,
      params: {
        clientId: cliente?.codigo,
        size: params?.size || 20,
        page: params?.page || 0,
        ...(params?.name && { name: params.name }),
        ...(params?.status && { status: params.status }),
        ...(params?.productIds && { productIds: params.productIds }),
        ...(params?.storeIds && { storeIds: params.storeIds }),
        ...(params?.authors && { authors: params.authors }),
        ...(params?.campaigns && { orders: params.campaigns }),
        ...(params?.clusters && {
          clusters: params.clusters,
        }),
        ...(params.sort && { sort: params.sort }),
      },
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'comma' });
      },
    }).then(resp => resp.data),
  );
};

export const deleteCampanha = id => {
  const cliente = getCliente();
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/campaigns/${id}`,
      method: 'DELETE',
      expectToken: true,
      params: {
        clientId: cliente?.codigo,
      },
    }).then(resp => resp),
  );
};

export const getLojas = params => {
  const cliente = getCliente();
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/campaigns/stores/all`,
      method: 'GET',
      expectToken: true,
      params: {
        clientId: cliente?.codigo,
        size: 200,
        page: 0,
        ...(params?.storeName && { storeName: params.storeName }),
      },
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }).then(resp => resp.data),
  );
};

export const getClusters = () => {
  const cliente = getCliente();
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/setup/stores/clusters`,
      method: 'GET',
      expectToken: true,
      params: {
        clientId: cliente?.codigo,
      },
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }).then(resp => resp.data),
  );
};

export const getAuthors = params =>
  api({
    url: `${process.env.REACT_APP_IPA_URL}/campaign/campaigns/authors`,
    method: 'GET',
    expectToken: true,
    params: {
      clientId: getCliente()?.codigo,
      size: params.size || 20,
      page: params.page || 0,
    },
    paramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  }).then(resp => {
    if (!resp.data) {
      return [];
    }

    return (
      resp.data?.map(item => ({
        value: item,
        label: item,
      })) || []
    );
  });

export const getStatus = params =>
  api({
    url: `${process.env.REACT_APP_IPA_URL}/campaign/campaigns/status`,
    method: 'GET',
    expectToken: true,
    params: {
      size: params?.size || 20,
      page: params?.page || 0,
    },
  }).then(resp => {
    if (!resp.data) {
      return [];
    }

    return resp.data.map(item => ({
      value: item,
      label: item === 'CURRENT' ? 'Vigente' : item === 'SCHEDULED' ? 'Programada' : item === 'DRAFT' ? 'Rascunho' : 'Encerrada',
    }));
  });

// CAMPANHA
export const getCampaignTypes = () => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/type`,
      method: 'GET',
      expectToken: true,
    }).then(response => {
      return (
        response.data?.map(item => ({
          value: item.order.toString(),
          label: item.name,
          order: item.order,
          id: item.id,
        })) || []
      );
    }),
    '',
  );
};
